"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlowGrid = void 0;
exports.hasGrid = hasGrid;
var flickity_1 = __importDefault(require("flickity"));
var config_1 = require("../config");
var FlowGrid = /*#__PURE__*/function () {
  function FlowGrid() {
    _classCallCheck(this, FlowGrid);
    this.grid = null;
    this.items = null;
    this.resizeAllGridItems = this.resizeAllGridItems.bind(this);
    this.grid = document.querySelector(config_1.CONFIG.flowGrid.grid);
    this.items = document.querySelectorAll(config_1.CONFIG.flowGrid.item);
    var _swipeableGrid = new flickity_1["default"](this.grid, config_1.CONFIG.flowGrid.flickityOptions);
    this.resizeAllGridItems();
    window.addEventListener('load', this.resizeAllGridItems);
    window.addEventListener('resize', this.resizeAllGridItems);
  }
  return _createClass(FlowGrid, [{
    key: "resizeGridItem",
    value: function resizeGridItem(item) {
      var rowHeight = this.getPropertyValueAsNumber('grid-auto-rows');
      var rowGap = this.getPropertyValueAsNumber('grid-row-gap');
      var rowSpan = Math.ceil((item.querySelector(config_1.CONFIG.flowGrid.itemContent).getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
      item.style.gridRowEnd = 'span ' + rowSpan;
    }
  }, {
    key: "resizeAllGridItems",
    value: function resizeAllGridItems() {
      var _this = this;
      Array.from(this.items).forEach(function (element) {
        _this.resizeGridItem(element);
      });
    }
  }, {
    key: "getPropertyValueAsNumber",
    value: function getPropertyValueAsNumber(value) {
      return Number(window.getComputedStyle(this.grid).getPropertyValue(value).replace('px', ''));
    }
  }]);
}();
exports.FlowGrid = FlowGrid;
function hasGrid() {
  if (document.querySelectorAll(config_1.CONFIG.flowGrid.grid).length > 0) {
    return true;
  }
  return false;
}